var map = {
	"./load_more_comments/controller.js": 43885,
	"./show_replies/controller.js": 3541,
	"src/decidim/comments/controllers/load_more_comments/controller.js": 43885,
	"src/decidim/comments/controllers/show_replies/controller.js": 3541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9871;